import React from 'react';
import { PopupData } from '../types';
import '../../styles/pws-popup-content.scss';
import { LinkButton } from 'forms';

interface Props {
    popup: PopupData;
    onLinkButtonClick: () => void;
}

const PwsPopupContent = ({
    popup,
    onLinkButtonClick,
}: Props) => {
    return <div className="pws-popup-content"
        style={{
            backgroundImage: `url('${popup.backgroundImage}')`,
        }}>
        <div
            className="pws-popup-content-content"
            dangerouslySetInnerHTML={{ __html: popup.content }}
        />
        {(!!popup.linkText) && <div className="pws-popup-content-link">
            <LinkButton
                onClick={onLinkButtonClick}
                btn="primary"
                href={popup.linkUrl}
                text={popup.linkText}
            />
        </div>}
    </div>;
};

export default PwsPopupContent;
